// = Libs =
import { FC } from 'react';
import clsx from 'clsx';

// = Styles =
import classes from './button.module.scss';

// = Types =
import { ButtonProps } from './button.types';

const Button: FC<ButtonProps> = (props) => {
  const {
    children,
    type = 'button',
    color = 'default',
    size = 'default',
    className,
    onClick,
    fullWidth,
  } = props;

  return (
    <button
      type={type}
      className={clsx(
        {
          [classes['button']]: true,
          [classes[`button__color--${color}`]]: color,
          [classes[`button__size--${size}`]]: size,
          [classes[`button--fullwidth`]]: fullWidth,
        },
        className
      )}
      onClick={onClick}>
      {children}
    </button>
  );
};

export default Button;
